// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__7_AmX","clinicsSelect":"TableHeading_clinicsSelect__26zcx"};